import { render, staticRenderFns } from "./ComponentBar.vue?vue&type=template&id=0168fff4&scoped=true&"
import script from "./ComponentBar.vue?vue&type=script&lang=js&"
export * from "./ComponentBar.vue?vue&type=script&lang=js&"
import style0 from "./ComponentBar.vue?vue&type=style&index=0&id=0168fff4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0168fff4",
  null
  
)

export default component.exports